import React, { useEffect, useState } from "react";
import { post, get } from "../../helpers/api_helper";
//redux
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import Loader from "common/loader";
import { Trans } from "react-i18next";
import Breadcrumb from "components/Common/Breadcrumb";
import { UPDATE_TERM, LANGUAGES_SEARCH, SHOW_TEXT } from "helpers/api_endpoints";

const UpdateTerm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [value, setValue] = useState('');
    const [valued, setValued] = useState([]);
    const [named, setNamed] = useState([]);
    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // console.log(languages);
                setLoading(false);
            })
            .catch(error => {
                navigate('/reasons');
            })
    }, []);

    useEffect(() => {
        const term = location.state;
        console.log(term)
        setId(term.id);
        get(`${SHOW_TEXT}/`+term.id)
            .then(response => {
                setName(JSON.stringify(response.data.named));
                setValue(JSON.stringify(response.data.valued));
                setValued(response.data.valued);
                setNamed(response.data.named);
                setLoading(false);
                console.log('valued', valued)
            })
    }, []);

    const handleSubmit = () => {
        post(UPDATE_TERM, { id, name, value })
            .then(response => {
                if (response.code == 200) {
                    navigate('/terms', { state: { successMsg: 'Updated SuccessFully' } });
                }
            })
    }
    const handleName = (languageId,value) => {
        if(!named.title){
            setNamed({"title":[{"1":""}]});
            return;  
        } 
        const ln = named.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            named.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(named));             
    }
    
    const handleContent = (languageId,value) => {
        if(!valued.title){
            setValued({"title":[{"1":""}]});
            return;  
        } 
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setValue(JSON.stringify(valued));             
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumb title="Terms & Conditions" breadcrumbItem="Edit Terms & Conditions" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            languages.map((language, index) => (
                                            <Row key={index}>
                                                <div className="form-group col-md-12 mt-2">
                                                    <Label className="form-label"><Trans>Title ({language.name})</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={named.title?named.title.find(el => {return el[language.id]})?named.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(named)}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => handleName(language.id,e.target.value)}
                                                        required={language.id==1||language.id==2?true:false} ></Input>
                                                    <Input type="hidden" name="id"></Input>
                                                </div>

                                                <div className="form-group col-md-12 mt-2">
                                                    <Label className="form-label"><Trans>Description</Trans></Label>
                                                    <textarea
                                                        name="description"
                                                        value={valued.title?valued.title.find(el => {return el[language.id]})?valued.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(valued)}
                                                        rows={5}
                                                        className="form-control"
                                                        placeholder="Enter Description"
                                                        type="text"
                                                        onChange={(e) => handleContent(language.id,e.target.value)}
                                                        required={language.id==1||language.id==2?true:false} ></textarea>
                                                </div>


                                            </Row>
                                        ))}
                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UpdateTerm;